import { TFunction } from 'i18next';

import { SemanticType } from '../models/program';

export function translateSemanticType(t: TFunction, semanticType: SemanticType) {
  return t(`program.semanticType.${semanticType.toLowerCase()}`);
}
